import React, {Component} from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import {withAlert} from 'react-alert'
import {config} from '../../config';
import 'rc-time-picker/assets/index.css';
import Loading from "../Loading";
import { getMapLib, createMapInstance, isNeshan } from '../../utils/mapHelper';

const nmp_mapboxgl = getMapLib();

let map;
let bounds;
let polygon;
let polygonMarkers = [];
let drawingEnabled = true;

class UpdateArea extends Component{

    constructor(props) {
        super(props);

        this.state={
            data: [],
            mapTypesListIsOpen: false,
            isSaveAreaOpen:false,
            mapType: isNeshan ? 'neshanVector' : 'osm',
            tracers:[],
            selectedTracer:0,
            sendSms:0,
            areaTitle:'',
            loading:false
        };

        this.coordinates = [];

        this.onScriptLoad = this.onScriptLoad.bind(this);
        this.closeMapTypsList = this.closeMapTypsList.bind(this);
        this.reloadMap = this.reloadMap.bind(this);
        this.getUpdatingArea = this.getUpdatingArea.bind(this);
        this.removePolygon = this.removePolygon.bind(this);
        this.updateEditingArea = this.updateEditingArea.bind(this);
        this.finishDrawing = this.finishDrawing.bind(this);
        this.zoomIn = this.zoomIn.bind(this);
        this.zoomOut = this.zoomOut.bind(this);
    }
    finishDrawing() {
        if (this.coordinates.length < 3) {
            this.props.alert.error("برای ایجاد محدوده، حداقل ۳ نقطه روی نقشه انتخاب کنید.");
            return;
        }
        drawingEnabled = false;
        this.drawPolygonOnMap();
    }
    onScriptLoad(mapType) {
        map = createMapInstance({
            container: document.getElementById("myMap"),
            mapType: mapType || this.state.mapType,
            zoom: 14,
            center: [46.270212, 38.0843038]
        });

        if (map.doubleClickZoom) {
            map.doubleClickZoom.disable();
        }

        drawingEnabled = true;
        this.coordinates = [];
        polygonMarkers = [];

        map.on('click', (e) => {
            if (!drawingEnabled) return;

            const isFirstPoint = this.coordinates.length === 0;

            this.coordinates.push({
                lat: e.lngLat.lat,
                lng: e.lngLat.lng
            });

            let markerEl = document.createElement('div');
            markerEl.style.width = isFirstPoint ? '14px' : '10px';
            markerEl.style.height = isFirstPoint ? '14px' : '10px';
            markerEl.style.backgroundColor = isFirstPoint ? '#28a745' : '#3D8DF9';
            markerEl.style.borderRadius = '50%';
            markerEl.style.border = '2px solid #fff';
            markerEl.style.cursor = 'pointer';
            if (isFirstPoint) {
                markerEl.title = 'نقطه شروع (برای بستن محدوده پس از حداقل ۳ نقطه کلیک کنید)';
            }

            let m = new nmp_mapboxgl.Marker({ element: markerEl })
                .setLngLat([e.lngLat.lng, e.lngLat.lat])
                .addTo(map);
            polygonMarkers.push(m);

            if (isFirstPoint) {
                markerEl.addEventListener('click', (ev) => {
                    ev.stopPropagation();
                    if (this.coordinates.length >= 3 && drawingEnabled) {
                        this.finishDrawing();
                    }
                });
            }

            this.drawPolygonOnMap();
        });

        map.on('dblclick', (e) => {
            if (!drawingEnabled) return;
            e.preventDefault();
            if (this.coordinates.length > 3) {
                const last = this.coordinates[this.coordinates.length - 1];
                const prev = this.coordinates[this.coordinates.length - 2];
                if (Math.abs(last.lat - prev.lat) < 0.0001 && Math.abs(last.lng - prev.lng) < 0.0001) {
                    this.coordinates.pop();
                    const lastM = polygonMarkers.pop();
                    if (lastM) lastM.remove();
                }
            }
            if (this.coordinates.length >= 3) {
                this.finishDrawing();
            }
        });
    }
    drawPolygonOnMap() {
        if (map.getLayer('polygon-fill')) map.removeLayer('polygon-fill');
        if (map.getLayer('polygon-outline')) map.removeLayer('polygon-outline');
        if (map.getSource('polygon')) map.removeSource('polygon');

        if (this.coordinates.length < 2) return;

        let coords = this.coordinates.map(c => [c.lng, c.lat]);
        let closed = [...coords, coords[0]];

        map.addSource('polygon', {
            type: 'geojson',
            data: {
                type: 'Feature',
                geometry: {
                    type: 'Polygon',
                    coordinates: [closed]
                }
            }
        });
        map.addLayer({
            id: 'polygon-fill',
            type: 'fill',
            source: 'polygon',
            paint: {
                'fill-color': '#3D8DF9',
                'fill-opacity': 0.3
            }
        });
        map.addLayer({
            id: 'polygon-outline',
            type: 'line',
            source: 'polygon',
            paint: {
                'line-color': '#3D8DF9',
                'line-width': 2
            }
        });
    }
    chanegMapType(type){
        this.onScriptLoad();
        this.setState({mapType: type , isInfoBoxOpen: false});
    }
    closeMapTypsList(){
        this.setState({mapTypesListIsOpen: false});
    }
    reloadMap(){
        this.onScriptLoad();
        this.setState({isSaveAreaOpen: false})
    }
    zoomIn(){
        if (map) {
            map.zoomIn();
        }
    }
    zoomOut(){
        if (map) {
            map.zoomOut();
        }
    }
    updateEditingArea(){
        this.setState({loading: true});
        console.log(this.coordinates);
        let data = {
            'send_sms' : this.state.sendSms ,
            'name': this.state.areaTitle ,
            'coordinates': this.coordinates
        };
        let req = {
            method: 'put',
            url: config.baseUrl + 'api/v2/clients/tracers/'+this.state.selectedTracer+'/geo-areas/'+this.props.match.params.geoId,
            headers: {
                Authorization: "Bearer " + config.token
            },
            data: data,
        };
        axios(req
        ).then((resp) => {
            if(resp.data.status === 1) {
                this.setState({loading:false});
                this.props.history.push('/areaslist');
                this.props.alert.success('تغییرات با موفقیت ثبت شد.');
            }

        }).catch((err) => {
            console.log(err);
            this.setState({loading:false});
            this.props.alert.error('مشکلی پیش آمده دوباره تلاش کنید.');
        });
    }
    getUpdatingArea(){
        this.setState({loading: true ,isSaveAreaOpen: true});
        this.coordinates = [];

        let req = {
            method: 'get',
            url: config.baseUrl + 'api/v2/clients/tracers/'+this.props.match.params.tracerId+'/geo-areas/'+this.props.match.params.geoId,
            headers: {
                Authorization: "Bearer " + config.token
            }
        };
        axios(req).then((resp) => {
            if (resp.data.status === 1) {

                this.coordinates = resp.data.data.coordinates;
                drawingEnabled = false;

                bounds = new nmp_mapboxgl.LngLatBounds();
                for(let i in this.coordinates) {
                    bounds.extend([this.coordinates[i].lng, this.coordinates[i].lat]);
                }

                this.drawPolygonOnMap();

                for (let c of this.coordinates) {
                    let markerEl = document.createElement('div');
                    markerEl.style.width = '10px';
                    markerEl.style.height = '10px';
                    markerEl.style.backgroundColor = '#3D8DF9';
                    markerEl.style.borderRadius = '50%';
                    markerEl.style.border = '2px solid #fff';
                    let m = new nmp_mapboxgl.Marker({ element: markerEl })
                        .setLngLat([c.lng, c.lat])
                        .addTo(map);
                    polygonMarkers.push(m);
                }

                map.fitBounds(bounds, { padding: 150, maxZoom: 14, maxDuration: 100 });
                map.panTo(bounds.getCenter());

                this.setState({
                    areaTitle: resp.data.data.name,
                    selectedTracer: resp.data.data.tracer.id,
                    sendSms: resp.data.data.send_sms,
                    loading:false
                });
            }
        }).catch(err => {
            console.log(err);
        });
    }
    removePolygon(){
        this.coordinates = [];
        if (map.getLayer('polygon-fill')) map.removeLayer('polygon-fill');
        if (map.getLayer('polygon-outline')) map.removeLayer('polygon-outline');
        if (map.getSource('polygon')) map.removeSource('polygon');
        for (let m of polygonMarkers) {
            m.remove();
        }
        polygonMarkers = [];
        drawingEnabled = true;
    }
    componentDidMount() {
        this.onScriptLoad();

        let req = {
            method: 'get',
            url: config.baseUrl + 'api/v2/clients/tracers',
            headers: {
                Authorization: "Bearer " + config.token
            }
        };
        axios(req).then((resp) => {
            if (resp.data.status === 1) {
                this.setState({
                    tracers: resp.data.data
                });
            }
        }).catch(err => {
            console.log(err);
        });

        this.getUpdatingArea();
    }

    render(){


        return(
            <div>
                <Loading loading={this.state.loading}/>
                <div id={"myMap"} className='Map col-lg-12 col-md-12'/>

                <button title='کوچک‌نمایی' className='map-btn' style={{bottom: '120px'}} onClick={this.zoomOut}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3D8DF9" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block", verticalAlign: "middle", marginTop: "3px" }}>
                        <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                </button>
                <button title='بزرگ‌نمایی' className='map-btn' style={{bottom: '170px'}} onClick={this.zoomIn}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3D8DF9" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block", verticalAlign: "middle", marginTop: "3px" }}>
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                </button>
                <button title='بارگذاری مجدد' className='map-btn' style={{bottom: '70px'}} onClick={this.reloadMap}>
                    <i className='icon-mapRefresh'></i>
                </button>
                <button title='نقشه ها' className='map-btn' style={{bottom: '20px'}} onClick={()=>this.setState({mapTypesListIsOpen: true})}>
                    <i className='icon-world'></i>
                </button>

                <div className={'infoBox saveArea'} style={{display: this.state.isSaveAreaOpen === true ? 'block' : 'none'}}>
                    <div className='half'>
                        <div className='input-div '>
                            <h5>عنوان</h5>
                            <div className='input-group'>
                                <input defaultValue={this.state.areaTitle} onChange={(e)=>{this.setState({areaTitle: e.target.value})}} className='input' placeholder='محدوده شرکت' style={{textAlign: 'right' , paddingRight: '0' , direction:'rtl'}} />
                            </div>
                        </div>
                    </div>
                    <div className='half'>
                        <div className='input-div '>
                            <h5>ردیاب</h5>
                            <div className='input-group'>
                                <select disabled  defaultValue={this.state.selectedTracer}>
                                    <option value={0}> ردیاب</option>
                                    {this.state.tracers.map((key)=>
                                        <option selected={this.state.selectedTracer === key.id ? true : false} value={parseInt(key.id)}>{key.title}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='input-div ' style={{padding: '0 10px'}}>
                        <h5>نحوه اطلاع رسانی(در صورت خروج از محدوده مشخص شده)</h5>
                        <div className='input-group'>
                            <select defaultValue={this.state.sendSms} onChange={(e)=>{this.setState({sendSms:e.target.value})}}>
                                <option value={0}>ناتیفیکیشن</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={this.updateEditingArea} className='blueBtn btn' style={{padding: '12px 30px'}}>ذخیره محدوده انتخاب شده</button>
                    <button className='pinkBtn btn' style={{marginRight: '12px' , padding: '12px 15px'}} onClick={this.removePolygon}>حذف محدوده انتخابی</button>
                </div>
                <Modal
                    isOpen={this.state.mapTypesListIsOpen}
                    onRequestClose={this.closeMapTypsList}
                    style={{content : {top: 'calc(100vh / 5)'  ,left: '40%' , right: '40%'}}}
                >
                    <p>نقشه ها</p>
                    <ul>
                        {isNeshan ? (
                            <li>
                                <button onClick={()=>this.chanegMapType("neshanVector")}>
                                    <img src={require(`../../image/Ellipse-${this.state.mapType === "neshanVector" ?'1':'0'}@2x.png`)} alt="نقشه نشان"/>
                                    <p>نقشه نشان</p>
                                    <span className='radio'>
                                        <img src={require(`../../image/radio${this.state.mapType === "neshanVector" ? 'S' : 'U'}.png`)} alt="انتخاب"/>
                                    </span>
                                </button>
                            </li>
                        ) : (
                            <li>
                                <button onClick={()=>this.chanegMapType("osm")}>
                                    <img src={require(`../../image/Ellipse-${this.state.mapType === "osm" ?'1':'0'}@2x.png`)} alt="OpenStreetMap"/>
                                    <p>نقشه OpenStreetMap</p>
                                    <span className='radio'>
                                        <img src={require(`../../image/radio${this.state.mapType === "osm" ? 'S' : 'U'}.png`)} alt="انتخاب"/>
                                    </span>
                                </button>
                            </li>
                        )}
                    </ul>
                </Modal>

            </div>
        );
    }
}
export default withAlert(UpdateArea);